import "./App.css";
import Routes from "./routes/index";
import LeadsProvider from "./context/leads/Provider";

function App() {
  return (
    <LeadsProvider>
      <Routes />
    </LeadsProvider>
  );
}

export default App;
